module.exports = __webpack_public_path__ + "img/LogoTranserviLtda.1b49cee3.png";